module.exports = __webpack_public_path__ + "static/img/s58.e7c469a5.png";